import { cloneDeep } from '@/utils/utils'

function setGamerCondition (event) {
  const { extra, EventCode } = event
  const { getIngameData, currentSportEvents } = this
  const { gamerCondition } = getIngameData

  const value = cloneDeep(gamerCondition)

  value[extra.team === 1 ? 'home' : 'away'] = {
    eventCode: EventCode,
    title: currentSportEvents[EventCode].title
  }

  this.setIngameProperty({
    property: 'gamerCondition',
    value
  })
}

export default {
  // 'this' - $store
  byActionType: {},
  // 'this' - $store
  byEventType: {
    'GAMER_CONDITION_HEADACHE' (event) {
      setGamerCondition.call(this, event)
    },
    'GAMER_CONDITION_HIGH_TEMPERATURE' (event) {
      setGamerCondition.call(this, event)
    },
    'GAMER_CONDITION_INTOXICATION' (event) {
      setGamerCondition.call(this, event)
    },
    'GAMER_CONDITION_NORMAL' (event) {
      setGamerCondition.call(this, event)
    },
    'GAMER_CONDITION_TILT' (event) {
      setGamerCondition.call(this, event)
    },
    'START_OVERTIME_PERIOD' () {
      this.setIngameProperty({
        property: 'fouls',
        value: {
          home: 0,
          away: 0
        }
      })
    },
    'START_PERIOD' () {
      this.setIngameProperty({
        property: 'fouls',
        value: {
          home: 0,
          away: 0
        }
      })
    }
  },
  // 'this' - tradermode component instance
  // для кастомной логики отображения event
  eventTitles: {
    'ADJUST_SCORE' (event) {
      return this.$t('trader.adjust.points.title')
    }
  }
}
